<template>
  <div id="home-wrapper">
    <app-header></app-header>

    <carousel class="carousel"
              :autoplay="true"
              :autoplayHoverPause="true"
              :perPage="1"
              :paginationEnabled="false">
      <slide class="slide">
        <router-link tag="a" to="/event/swing_by">
          <img src="/static/img/press/press1.png">
        </router-link>
      </slide>
    </carousel>

    <div class="container home-speaker">
      <h2>Speakers</h2>
      <speaker-list :speakers="speakers.swing_by"></speaker-list>

      <div class="text-center">
        <router-link tag="button"
                     class="more-speaker-button btn btn-outline-secondary"
                     to="/speakers">
          More
        </router-link>
      </div>
    </div>

    <div class="container home-about">
      <div class="row">
        <div class="about-detail col-lg-4 col-md-12">
          <h3>TED</h3>
          <p>
            “Technology, Entertainment, Design” の略で、 “Ideas worth spreading”
            －広める価値のあるアイデア－の精神の下、多種多様なアイデアを世界中へ発信する非営利団体です。
            <br/><br/>
            1984年に米国で始まり、近年はカリフォルニア州の TEDConference、英国エジンバラの TEDGlobal がTEDの2大イベントとして定着しています。
            <br/>
            様々な分野から出演者を招き、18分以内のTalkやShowを通し、各々が抱く独特なアイデアを披露する世界的祭典を開催しています。
          </p>
        </div>
        <div class="about-detail col-lg-4 col-md-12">
          <h3>TEDx</h3>
          <p>
            TEDの “Ideas Worth Spreading” の理念を受け継ぎ、世界130カ国以上で発足している地域的コミュニティです。<br/>
            TEDから正式にライセンスを受け、TED同様の体験を共有することを目的とし、世界各地で独自にイベントが運営されています。<br/>
            TEDの定めた運用ルールに沿いながら、その地域ならではの独自性を発揮するという意味が “x”の文字に込められています。
          </p>
        </div>
        <div class="about-detail col-lg-4 col-md-12">
          <h3>TEDxOsakaU</h3>
          <p>
            TED、TEDxの理念に感銘を受け、“大阪大学から世界へアイデアを届けたい！”という意欲溢れる学生によるTEDxイベント開催団体です。<br/><br/>
            活気満ちる大阪のパワーと多彩で枠にとらわれないイベント創りが TEDxOsakaU の魅力です。<br/>
            大阪大学に集った”英知”が、日本、そして世界を変えていく―。<br/>
            阪大の更なる発展を目指し、我々は活動しています。
          </p>
        </div>
      </div>
    </div>

    <app-footer></app-footer>
  </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SpeakerList from '@/components/SpeakerList';
import SpeakersData from '@/assets/speakers.json';
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'Home',
  components: {
    'app-header': Header,
    'app-footer': Footer,
    'speaker-list': SpeakerList,
    carousel: Carousel,
    slide: Slide,
  },
  data() {
    return {
      speakers: SpeakersData,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/global";

#home-wrapper {
  margin-top: 63px;
  padding: 0;
}

.carousel {
  .slide {
    text-align: center;

    img {
      width: 75%;

      @include media-breakpoint-down(md) {
        width: 90%;
      }

      @include media-breakpoint-down(sm) {
        width: 96%;
      }
    }
  }
}

.home-speaker {
  width: 80%;
  margin-top: 36px;

  @include media-breakpoint-down(md) {
    width: 90%;
  }

  @include media-breakpoint-down(sm) {
    width: 100%;
  }

  h2 {
    margin: 14px 0 4px 24px;
  }

  .more-speaker-button {
    font-size: 18px;
    padding: 4px 32px;
  }
}

.home-about {
  margin-top: 48px;

  .about-detail {
    p {
      font-size: 16px;
    }

    h3 {
      margin: 2px 0 4px 8px;

      @include media-breakpoint-down(md) {
        font-size: 32px;
        margin-top: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue